export const EnsoMark = ({ className }) => (
  <svg viewBox="0 0 64 64" className={className} fill="none" aria-hidden="true">
    <path
      d="M32 14a18 18 0 1 0 17 24"
      stroke="currentColor"
      strokeWidth="5.5"
      strokeLinecap="round"
    />
  </svg>
);

export const Wordmark = ({ className = "", markClassName = "h-7 w-7" }) => (
  <span className={`inline-flex items-center gap-2.5 ${className}`}>
    <EnsoMark className={markClassName} />
    <span className="whitespace-nowrap font-display text-xl font-medium tracking-tight">
      Vagus Digital
    </span>
  </span>
);